import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";
import {IconClose, IconIndicatorWhite} from "../../Icon";
import Dragger from "antd/es/upload/Dragger";
import {formatDate, getImagePathWithTheme} from "../../utils";
import {message, Modal, Spin} from "antd";
import {t} from "i18next";
import {marginTop} from "html2canvas/dist/types/css/property-descriptors/margin";
import {LoadingOutlined} from "@ant-design/icons";
import Editor from "@/components/EditorV2";
import Global from "@/global";
import {
    EVENT_FAVIRIATE_CHANGE,
    EVENT_REFRESH_LIBRARY_LIST,
    EVENT_REFRESH_RECENTS,
    FROM_HISTORY,
    FROM_JOURNAL,
    MAP_MONTH, MAX_Z_INDEX, MEDIIUM_Z_INDEX
} from "@/Const";
import {libraryHistoryList} from "@model/libraryHistory";
import {getCardById, updateCard} from "@model/card";
import {postMessage} from "@/common/event";

let mCallback:any;
const DialogCardHistory = forwardRef((props, ref) => {
    useImperativeHandle(ref,()=>({
        onShowDialog:onShowDialog,
        onCloseDialog:onCloseDialog
    }))

    const [isShowDialog,setIsShowDialog] = useState(false);
    const [isLoading,setIsLoading] = useState(true);

    const editorRef = useRef(null);
    const [cardData,setCardData] = useState(null);
    const [arrayHistoryData,setArrayHistoryData] = useState([]);
    const [dialogSize,setDialogSize] = useState({width:'0px',height:'0px',maxHeight:'0px'})

    const idRef = useRef();
    const onShowDialog = (szId:any,callback:any)=>{
        mCallback = callback;
        setIsShowDialog(true);
        idRef.current = szId;

        setArrayHistoryData([]);
        setIsLoading(true);

        libraryHistoryList(szId).then(res=>{
            res = res.sort((a,b)=>{
                return b.historyTime - a.historyTime;
            })

            setTimeout(()=>{
                setIsLoading(false);
                setArrayHistoryData(res);
                if (res.length > 0){
                    res[0].isSelected = true;
                    const ccc = {...res[0]};
                    ccc.id = ccc.libraryId;
                    delete ccc.libraryId;
                    setCardData(ccc)
                }
            },1000)
        });
    }

    const onCloseDialog = ()=>{
        setIsShowDialog(false);
    }


    useEffect(() => {
        window.addEventListener('resize',eventResize);
        updateDialogSize()

        return () => {
            window.removeEventListener('resize',eventResize);
            mCallback = null;
        }
    },[])


    //更新大小
    function eventResize(event:any){
        updateDialogSize()
    }

    const updateDialogSize = ()=>{
        let nWidth = '100vw';
        let nHeight = '100vh';
        let nMaxHeight = '100vh';
        nWidth = (document.body.clientWidth*0.7)+'px';
        nHeight = (document.body.clientHeight*0.7)+'px';
        nMaxHeight = (document.body.clientHeight*0.9)+'px';

        setDialogSize({
            width: nWidth,
            height: nHeight,
            maxHeight:nMaxHeight
        })
    }

    const getEditorLRPadding = ()=>{
        const nW = document.body.clientWidth;
        return nW/10 + 'px';
    }

    return(
        <Modal centered={true} zIndex={MEDIIUM_Z_INDEX} width={dialogSize.width} bodyStyle={{height: dialogSize.height, margin: '-20px -24px',}}
               open={isShowDialog} closeIcon={<IconClose/>}
               onCancel={() => setIsShowDialog(false)} footer={null}>
            <div className='flex-center' style={{height: '100%',position:'relative'}}>
                {
                    isLoading &&
                    <div className={'flex-row-vertical-center'} style={{
                        position: 'absolute',
                        left: '50%',
                        top: '50%',
                        transform: 'translate(-50%,-50%)',
                    }}>
                        <Spin
                            spinning={true} indicator={<LoadingOutlined style={{fontSize: 26,}} spin/>}/>
                        <span className='ml-12'>{t("Loading")}</span>
                    </div>
                }

                {
                    !isLoading &&
                    <div
                        style={{display: 'grid', gridTemplateColumns: 'auto 1px 260px', width: '100%', height: '100%'}}>
                        <div style={{
                            padding: `0px ${getEditorLRPadding()}`,
                            overflowY: 'auto',
                            marginTop: '46px',
                            marginBottom: '26px'
                        }}>
                            {
                                cardData &&
                                <Editor ref={editorRef} data={cardData} from={FROM_HISTORY}/>
                            }
                        </div>

                        <div style={{background: 'var(--line-color)'}}></div>

                        <div style={{marginTop: '22px', padding: '0 0px', display: 'flex', flexDirection: 'column'}}>
                            <span className={'font-family-medium ml-16'}
                                  style={{fontSize: '16px', flexShrink: '0'}}>{t("Version history")}</span>
                            <div className={'flex-col'} style={{flexGrow: '1', paddingBottom: '16px'}}>
                                <div className={'flex-col mt-16'} style={{flexGrow: '1',height:`calc(${dialogSize.height} - 110px)`,overflow:'auto'}}>
                                    {
                                        arrayHistoryData.map(p => {
                                            return <div className={'flex-col cursor-pointer'} style={{
                                                padding: '6px 12px',
                                                borderRadius: '8px',
                                                minHeight: '62px',
                                                margin: '4px 8px',
                                                justifyContent: 'center',
                                                background: (p.isHover || p.isSelected) ? 'var(--tab-active-background-color)' : 'transparent'
                                            }} onMouseEnter={() => {
                                                var arrayNew = [...arrayHistoryData];
                                                arrayNew.forEach(p => p.isHover = false);
                                                p.isHover = true;
                                                setArrayHistoryData(arrayNew);
                                            }} onMouseLeave={() => {
                                                var arrayNew = [...arrayHistoryData];
                                                arrayNew.forEach(p => p.isHover = false);
                                                setArrayHistoryData(arrayNew);
                                            }} onClick={() => {
                                                var arrayNew = [...arrayHistoryData];
                                                arrayNew.forEach(p => p.isSelected = false);
                                                p.isSelected = true;
                                                setArrayHistoryData(arrayNew);
                                                const ccc = {...p};
                                                ccc.id = ccc.libraryId;
                                                delete ccc.libraryId;
                                                setCardData(ccc);
                                            }}>
                                                <span>{t(MAP_MONTH[`${new Date(p.historyTime).getMonth() + 1}`]) + formatDate(new Date(p.historyTime), ' dd, yyyy hh:mm')}</span>
                                                <span className={'mt-6 span-single-line'}>{p.name}</span>
                                            </div>
                                        })
                                    }
                                </div>
                                <div className={'flex-center'} style={{flexShrink: '0'}}>
                                    <span className={'button-solid-style flex-center'}
                                          style={{width: '164px'}} onClick={()=>{
                                        const selectItem:any = arrayHistoryData.find(p=>p.isSelected);
                                        if (!selectItem) {
                                            message.error(t("NoRestoreData"));
                                            return;
                                        }

                                        window.showMessageBox(t("Tips"),t("ConfirmRestore"),t("Cancel"),t("Restore"),null,()=>{
                                            setIsShowDialog(false);
                                            if (selectItem){
                                                const newCard = {...selectItem};
                                                newCard.id = newCard.libraryId;
                                                delete newCard.libraryId;
                                                updateCard(newCard).then(res=>{
                                                    if (mCallback){
                                                        newCard.doc = selectItem.doc;
                                                        mCallback(newCard);
                                                    }
                                                    if (newCard.type == 'card'){
                                                        message.info(t("CardRestoreTip"));
                                                    }

                                                    postMessage(EVENT_REFRESH_LIBRARY_LIST);
                                                    postMessage(EVENT_FAVIRIATE_CHANGE);
                                                    postMessage(EVENT_REFRESH_RECENTS);
                                                });
                                            }
                                        })
                                    }}>{t("Restore version")}</span>
                                </div>
                            </div>


                        </div>
                    </div>
                }

            </div>


        </Modal>
    )
})

export default DialogCardHistory;